import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail } from 'lucide-react';

/**
 * Template 14: JHAROKHA Footer
 * Teal bg, white text, 4 structured columns
 */
const Footer14 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) { setEmail(''); }
    };

    const shopLinks = [
        { label: 'All Collections', path: '/template14/shop' },
        { label: 'Structured Silhouettes', path: '/template14/shop' },
        { label: 'Geometric Prints', path: '/template14/shop' },
        { label: 'Architectural Drapes', path: '/template14/shop' },
        { label: 'Modern Ethnic', path: '/template14/shop' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template14/contact' },
        { label: 'Shipping Policy', path: '/template14/shipping-exchange' },
        { label: 'Returns & Exchange', path: '/template14/shipping-exchange' },
        { label: 'FAQs', path: '/template14/faqs' },
        { label: 'Track Order', path: '/template14/orders' },
    ];

    const infoLinks = [
        { label: 'About Us', path: '/template14/about' },
        { label: 'Privacy Policy', path: '/template14/privacy-policy' },
        { label: 'Terms & Conditions', path: '/template14/terms-conditions' },
    ];

    const renderLinkColumn = (title, links) => (
        <div>
            <h4 style={{ fontFamily: "'Archivo', sans-serif", fontSize: '13px', fontWeight: 600, color: '#FFFFFF', letterSpacing: '0.15em', textTransform: 'uppercase', margin: '0 0 20px 0' }}>
                {title}
            </h4>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                {links.map((link) => (
                    <li key={link.label} style={{ marginBottom: '12px' }}>
                        <button
                            onClick={() => navigate(link.path)}
                            style={{ fontFamily: "'Roboto', sans-serif", fontSize: '14px', fontWeight: 300, color: 'rgba(255,255,255,0.75)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, transition: 'color 0.3s' }}
                            onMouseEnter={(e) => { e.currentTarget.style.color = '#FFFFFF'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}
                        >
                            {link.label}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;600;700&family=Roboto:wght@300;400;500&display=swap');
                .jharokha-footer-grid { display: grid; grid-template-columns: 1fr; gap: 40px; }
                @media (min-width: 768px) { .jharokha-footer-grid { grid-template-columns: 1.5fr 1fr 1fr 1fr; gap: 48px; } }
            `}</style>

            <footer style={{ backgroundColor: '#0D9488' }}>
                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '64px 24px' }}>
                    <div className="jharokha-footer-grid">
                        {/* Column 1: Brand & Newsletter */}
                        <div>
                            <h3 style={{ fontFamily: "'Archivo', sans-serif", fontSize: '24px', fontWeight: 700, color: '#FFFFFF', letterSpacing: '3px', margin: '0 0 12px 0', textTransform: 'uppercase' }}>
                                JHAROKHA
                            </h3>
                            <p style={{ fontFamily: "'Roboto', sans-serif", fontSize: '14px', color: 'rgba(255,255,255,0.75)', lineHeight: 1.7, margin: '0 0 24px 0', fontWeight: 300 }}>
                                Architectural elegance meets modern Indian fashion. Structured silhouettes, geometric precision, timeless design.
                            </p>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '24px' }}>
                                {[Instagram, Facebook].map((Icon, i) => (
                                    <a key={i} href="#" style={{ width: '36px', height: '36px', border: '1px solid rgba(255,255,255,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFFFFF', transition: 'all 0.3s' }}
                                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#FFFFFF'; e.currentTarget.style.color = '#0D9488'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#FFFFFF'; }}
                                    >
                                        <Icon className="w-4 h-4" />
                                    </a>
                                ))}
                            </div>
                            <form onSubmit={handleSubscribe} style={{ display: 'flex', gap: '0' }}>
                                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email"
                                    style={{ fontFamily: "'Roboto', sans-serif", fontSize: '13px', padding: '10px 14px', backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRight: 'none', color: '#FFFFFF', outline: 'none', flex: 1, minWidth: 0 }}
                                />
                                <button type="submit" style={{ fontFamily: "'Archivo', sans-serif", fontSize: '11px', fontWeight: 600, padding: '10px 16px', backgroundColor: '#FFFFFF', color: '#0D9488', border: '1px solid #FFFFFF', cursor: 'pointer', letterSpacing: '0.1em', textTransform: 'uppercase', whiteSpace: 'nowrap', transition: 'all 0.3s' }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#0F766E'; e.currentTarget.style.color = '#FFFFFF'; e.currentTarget.style.borderColor = '#0F766E'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#FFFFFF'; e.currentTarget.style.color = '#0D9488'; e.currentTarget.style.borderColor = '#FFFFFF'; }}
                                >
                                    Subscribe
                                </button>
                            </form>
                        </div>

                        {renderLinkColumn('Shop', shopLinks)}
                        {renderLinkColumn('Customer Care', customerCareLinks)}

                        {/* Column 4: Information + Contact */}
                        <div>
                            <h4 style={{ fontFamily: "'Archivo', sans-serif", fontSize: '13px', fontWeight: 600, color: '#FFFFFF', letterSpacing: '0.15em', textTransform: 'uppercase', margin: '0 0 20px 0' }}>
                                Information
                            </h4>
                            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                                {infoLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <button onClick={() => navigate(link.path)}
                                            style={{ fontFamily: "'Roboto', sans-serif", fontSize: '14px', fontWeight: 300, color: 'rgba(255,255,255,0.75)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, transition: 'color 0.3s' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.color = '#FFFFFF'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}
                                        >
                                            {link.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                            <div style={{ marginTop: '24px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Mail className="w-4 h-4" style={{ color: 'rgba(255,255,255,0.6)' }} />
                                    <span style={{ fontFamily: "'Roboto', sans-serif", fontSize: '13px', color: 'rgba(255,255,255,0.75)', fontWeight: 300 }}>hello@jharokha.in</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Phone className="w-4 h-4" style={{ color: 'rgba(255,255,255,0.6)' }} />
                                    <span style={{ fontFamily: "'Roboto', sans-serif", fontSize: '13px', color: 'rgba(255,255,255,0.75)', fontWeight: 300 }}>+91 98765 43210</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ borderTop: '1px solid rgba(255,255,255,0.15)', padding: '20px 24px', textAlign: 'center' }}>
                    <p style={{ fontFamily: "'Roboto', sans-serif", fontSize: '12px', color: 'rgba(255,255,255,0.5)', margin: 0, fontWeight: 300 }}>
                        &copy; 2026 Jharokha. All rights reserved. Crafted with architectural precision.
                    </p>
                </div>
            </footer>
        </>
    );
};

export default Footer14;
